import React, { useState, useEffect } from 'react';
import './CondPopUpStyle.css';  // Die CSS-Datei für das Styling

interface PopupProps {
    tag: string;
    agbStatus: number;
    dsgvoStatus: number;
    useCondStatus: number;
}

const Popup: React.FC<PopupProps> = ({ agbStatus, dsgvoStatus, useCondStatus,tag }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [agbChecked, setAgbChecked] = useState(false);
  const [dsgvoChecked, setDsgvoChecked] = useState(false);
  const [useCondChecked, setUseCondChecked] = useState(false);

  useEffect(() => {
    // Nur anzeigen, wenn mindestens eine der Bedingungen geändert wurde
    if (agbStatus !== 1 || dsgvoStatus !== 1 || useCondStatus !== 1) {
      setIsVisible(true);
    }
  }, [agbStatus, dsgvoStatus, useCondStatus]);

  const handleAgbChange = (event: React.ChangeEvent<HTMLInputElement>) => setAgbChecked(event.target.checked);
  const handleDsgvoChange = (event: React.ChangeEvent<HTMLInputElement>) => setDsgvoChecked(event.target.checked);
  const handleUseCondChange = (event: React.ChangeEvent<HTMLInputElement>) => setUseCondChecked(event.target.checked);

  const handleLogin = async (tag:String) => {
    //console.log("keyword: " ,keyword)
    //console.log("street: " ,street)
    //console.log("postalCode: " ,postalCode)
    //console.log("place: " ,place)
    //console.log("tag: " ,tag)

    try {
      const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/ChangePaperAccount.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tag,
        }),
      });
      


      if (response.ok) {
        //const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        console.log('Erfolgreich gesendet');
      } else {
        //const data = await response.json();
        //console.log(data);
        console.error('Fehler Response:', response.statusText);
      }
    } catch (error) {
      console.error('Fehler beim senden:', error);
    }
  };


  const handleConfirm = () => {
    // Überprüfen, ob der Benutzer alle geänderten Bedingungen akzeptiert hat
    const canConfirm =
      (agbStatus !== 1 && agbChecked) || agbStatus === 1 &&
      (dsgvoStatus !== 1 && dsgvoChecked) || dsgvoStatus === 1 &&
      (useCondStatus !== 1 && useCondChecked) || useCondStatus === 1;

    if (canConfirm) {
      setIsVisible(false);
      //alert('Änderungen wurden bestätigt');
      handleLogin(tag)  
    } else {
      alert('Bitte akzeptieren Sie alle geänderten Bedingungen');
    }
  };

  return (
    <div className={`popup-background ${isVisible ? 'visible' : ''}`}>
      <div className="popup-container">
        <h2>Änderungen an Bedingungen</h2>
        <p>Bitte bestätigen Sie die Änderungen an den folgenden Bedingungen:</p>

        {agbStatus !== 1 && (
          <div className="checkbox-item">
            <input type="checkbox" id="accept-agbs" checked={agbChecked} onChange={handleAgbChange} />
            <label htmlFor="accept-agbs">
              Ich akzeptiere die <a href="https://mbsoftwaresolutions.de/produkte/apps/junioralarm/agb" target="_blank" rel="noopener noreferrer">AGBs</a>
            </label>
          </div>
        )}

        {dsgvoStatus !== 1 && (
          <div className="checkbox-item">
            <input type="checkbox" id="accept-dsgvo" checked={dsgvoChecked} onChange={handleDsgvoChange} />
            <label htmlFor="accept-dsgvo">
              Ich akzeptiere die <a href="https://mbsoftwaresolutions.de/produkte/apps/junioralarm/datenschutzerklaerung" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a>
            </label>
          </div>
        )}

        {useCondStatus !== 1 && (
          <div className="checkbox-item">
            <input type="checkbox" id="accept-useCond" checked={useCondChecked} onChange={handleUseCondChange} />
            <label htmlFor="accept-useCond">
              Ich akzeptiere die <a href="https://mbsoftwaresolutions.de/produkte/apps/junioralarm/nutzungsbedingungen" target="_blank" rel="noopener noreferrer">Nutzungsbedingungen</a>
            </label>
          </div>
        )}

        <button className="accept-button" onClick={handleConfirm}>Bestätigen</button>
      </div>
    </div>
  );
};

export default Popup;